export let flagUnflag_Button = "g3VWWb";
export let flagUnflag_Button_MLR = "e4u0Tb";
export let flagCompleteToday_Button = "xTUEHe";
export let flagCompleteTomorrow_Button = "puqAUe";
export let flagCompleteThisWeek_Button = "gUWhW";
export let flagCompleteNextWeek_Button = "ND79Ie";
export let flagCompleteCustom_Button = "nv50Ac";
export let flagCompleteNoDate_Button = "NrLrg";
export let flagMarkComplete_Button = "xmyvsb";
export let flagClearFlag_Button = "CSfWC";
export let flagAddReminder_Button = "e5heHc";
export let flagEditReminder_Button = "JPjyxd";
export default {flagUnflag_Button,flagUnflag_Button_MLR,flagCompleteToday_Button,flagCompleteTomorrow_Button,flagCompleteThisWeek_Button,flagCompleteNextWeek_Button,flagCompleteCustom_Button,flagCompleteNoDate_Button,flagMarkComplete_Button,flagClearFlag_Button,flagAddReminder_Button,flagEditReminder_Button};